var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "main-container",
      class: _vm.colorMode === "dark" ? "dark-block" : "",
    },
    [
      _c("h2", [_vm._v("What is a Market Map?")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Market maps can help you shortlist and verify the top companies in a target country and sub-sector enabling you to isolate legitimate clients, customers, distributors or competitors to support your Africa growth strategy. Asoko's market maps are leveraged by leading investors, banks and MNCs across the globe looking to cut down on their research costs."
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Data included for each company comprises: registered name and address, registration ID, incorporation date, sub-sector classification and principal activities, revenue band, shareholder description and key personnel."
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "action-wrap" }, [
        _c(
          "a",
          {
            staticClass: "cta-button",
            class: _vm.colorMode === "light" ? "medium-button" : "",
            on: { click: _vm.openMarketMap },
          },
          [_vm._v("Learn More")]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }